import {AppStartListening} from "../../store";
import {ListenerEffectAPI, Unsubscribe} from "@reduxjs/toolkit";
import {handleLogin, handleRegisterSuccess} from "./slice";
import {loadUser, refreshSession} from "./asyncActions";

const handlePostLogin = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(refreshSession())
}

const handleLoadUserAfterPostSession = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(loadUser())
}

export function setupSessionListeners(startListening: AppStartListening): Unsubscribe {
    const subscriptions: any[] = [
        startListening({
            actionCreator: handleLogin,
            effect: handlePostLogin,
        }),
        startListening({
            actionCreator: handleRegisterSuccess,
            effect: handlePostLogin,
        }),
        startListening({
            actionCreator: refreshSession.fulfilled,
            effect: handleLoadUserAfterPostSession,
        }),
    ]

    return () => {
        subscriptions.forEach((unsubscribe) => unsubscribe())
    }
}